import { useAuth } from '../../contexts/AuthContext';
import Sidebar from '../../components/Layout/Sidebar';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function Dashboard() {
  const { user } = useAuth();

  // Dummy data for Income vs Expenses Bar Chart
  const barData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Income',
        data: [5000, 6000, 5500, 7000, 6500, 8000],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        label: 'Expenses',
        data: [4000, 4500, 4200, 5000, 4800, 5500],
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Dummy data for Expense Categories Pie Chart
  const pieData = {
    labels: ['Rent', 'Utilities', 'Food', 'Transportation', 'Entertainment'],
    datasets: [
      {
        data: [1200, 300, 800, 500, 200],
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 md:ml-64 mt-14 md:mt-0 px-4 py-4 md:px-6 md:py-6">
        <div className="mb-4">
          <h1 className="text-2xl font-semibold">Welcome, {user?.name}!</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Income vs Expenses Bar Chart */}
          <div className="bg-white p-6 rounded shadow">
            <h2 className="text-xl font-bold mb-4">Income vs Expenses</h2>
            <div className="h-64">
              <Bar data={barData} options={chartOptions} />
            </div>
          </div>

          {/* Expense Categories Pie Chart */}
          <div className="bg-white p-6 rounded shadow">
            <h2 className="text-xl font-bold mb-4">Expense Categories</h2>
            <div className="h-64">
              <Pie data={pieData} options={chartOptions} />
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-white p-6 rounded shadow md:col-span-2">
            <h2 className="text-xl font-bold mb-2">Financial Summary</h2>
            <p className="text-gray-700">Track your income, expenses, and financial goals in one place.</p>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-gray-50 p-4 rounded">
                <h3 className="text-lg font-semibold">Total Income</h3>
                <p className="text-2xl text-green-600">$33,000</p>
              </div>
              <div className="bg-gray-50 p-4 rounded">
                <h3 className="text-lg font-semibold">Total Expenses</h3>
                <p className="text-2xl text-red-600">$27,500</p>
              </div>
              <div className="bg-gray-50 p-4 rounded">
                <h3 className="text-lg font-semibold">Net Savings</h3>
                <p className="text-2xl text-blue-600">$5,500</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}